export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontem"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hoje"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Segunda-feira"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terça-feira"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quarta-feira"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quinta-feira"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sexta-feira"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábado"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Domingo"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["janeiro"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["fevereiro"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["março"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["abril"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["maio"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["junho"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["julho"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["agosto"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["setembro"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["outubro"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["novembro"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["dezembro"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Você"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrador"])}
}